import DailyProfitReport from "./DailyProfitReport";

export default DailyProfitReport;
